import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/Disclaimer.css';
import Swal from 'sweetalert2';

const Disclaimer = () => {
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  // Handle checkbox change
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  // Handle button click, check if checkbox is checked
  const handleButtonClick = () => {
    if (isChecked) {
      navigate('/home');
    } else {
      showAlert();
    }
  };

  // Show SweetAlert2 alert
  const showAlert = () => {
    Swal.fire({
      title: 'You Have Not Agreed!',
      icon: 'error', // Correct icon type
      confirmButtonText: 'Ok'
    });
  };

  return (
    <div className='disclaimerBody d-flex justify-content-center align-items-center'>
      <div className='DisclaimerBox d-flex flex-column justify-content-center align-items-center p-3 gap-2'>
        <div className='disclaimer text'>Disclaimer</div>
        <div className='text text-wrap text-justify disclaimer-text fw-bold'>
      The Bar Council of India does not permit advertisement or solicitation by advocates in any form or manner.
      By accessing this website, kanwallwaliaassociates.com, you acknowledge and confirm that you are seeking 
      information relating to Kanwal Walia Law Firm of your own accord and that there has been no form of 
      solicitation, advertisement or inducement by Kanwal Walia Law Firm or its members. The content of this 
      website is for informational purposes only and should not be interpreted as soliciting or advertisement. 
      No material/information provided on this website should be construed as legal advice. Kanwal Walia Law Firm 
      shall not be liable for consequences of any action taken by relying on the material/information provided 
      on this website. The contents of this website are the intellectual property of Kanwal Walia Law Firm.
    </div>
        <div className='d-flex justify-content-center align-items-center gap-1'>
          <input 
            type='checkbox' 
            checked={isChecked}
            onChange={handleCheckboxChange} // Handle checkbox change
          />
          <div className='text'>I accept the above</div>
        </div>
        <button onClick={handleButtonClick} className='text disclaimerBtn' id='agree'>I Agree</button>
      </div>
    </div>
  );
};

export default Disclaimer;
